import { useTranslation } from 'react-i18next';
import { PublicLayout } from '../layout/PublicLayout.tsx';
import styles from './Page.module.css';
import { ReleaseDownloads } from './ReleaseDownloads.tsx';

export function DownloadPage() {
  const { t } = useTranslation('admin');
  return (
    <PublicLayout wide>
      <section className={styles['card']}>
        <h1 className={styles['title']}>{t('download.title')}</h1>
        <ReleaseDownloads />
      </section>
    </PublicLayout>
  );
}
